
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/p/[slug]/[akl]",
      function () {
        return require("private-next-pages/[lang]/p/[slug]/[akl]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/p/[slug]/[akl]"])
      });
    }
  